import { hasRole, hasRoles ,hasUser} from "./utils/Utils"


export function getMenu() {

  let menu = [{
    text: 'Ana Sayfa',
    path: '/home',
    icon: 'home'
  }];

      //sgkIslemleri meu-forms
      if (hasUser("tbc.admin") && hasRoles(["yoneticirapor|yoneticirapor|maasOrtalamaRaporu"])) {
        let sgkIslemleriMenu = {
          text: 'Yönetici İşlemleri',
          icon: 'folder',
          items: []
        };
        if (hasRole("yoneticirapor|yoneticirapor|maasOrtalamaRaporu")) {
          sgkIslemleriMenu.items.push({
            text: 'Meslek Maaş Ortalama Raporu',
            path: '/maasOrtalamaRapor'
          });
        } 
    
        menu.push(sgkIslemleriMenu);
      }

      

    //sgkIslemleri meu-forms
    if (hasRoles(["sgkIslemleri|sgkDonemIslemleri|listele","sgkIslemleri|sgkDonemIslemleri|raporUcretiHesapla"])) {
      let sgkIslemleriMenu = {
        text: 'Hesaplama İşlemleri',
        icon: 'folder',
        items: []
      };
      if (hasRole("sgkIslemleri|sgkDonemIslemleri|listele")) {
        sgkIslemleriMenu.items.push({
          text: 'Hesaplama İşlemleri',
          path: '/sgkislem'
        });
      }

      if (hasRole("sgkIslemleri|sgkDonemIslemleri|raporUcretiHesapla")) {
        sgkIslemleriMenu.items.push({
          text: 'Rapor Ücret İşlemleri',
          path: '/raporucretislemileri'
        });
      }

      // if (hasRole("sgkIslemleri|sgkDonemIslemleri|raporUcretiHesapla")) {
      //   sgkIslemleriMenu.items.push({
      //     text: 'Potansiyel Teşvik Sorgulama',
      //     path: '/potansiyeltesviksorgulama'
      //   });
      // }

      menu.push(sgkIslemleriMenu);
    }

    
  //bildirgeislemleri meu-forms
  if (hasRoles(["bildirge|bildirgeislemleri|listele", "bildirge|bildirgeDetay|listele"])) {
    let bildireIslemleriMenu = {
      text: 'Bildirge İşlemleri',
      icon: 'folder',
      items: []
    };
    if (hasRole("bildirge|bildirgeislemleri|listele")) {
      bildireIslemleriMenu.items.push({
        text: 'Sgk Bildirge İşlemleri',
        path: '/bildirge'
      });
    }
    if (hasRole("bildirge|bildirgeDetay|listele")) {
      bildireIslemleriMenu.items.push({
        text: 'Bildirge Detay',
        path: '/personeldetay'
      });
    }

    menu.push(bildireIslemleriMenu);
  }

  //tesvikislemleri meu-forms
  if (hasRoles(["tesvik|tesvikislemleri|listele", "tesvik|tesvikDetayIslemleri|listele"])) {
    let tesvikIslemleriMenu = {
      text: 'Teşvik İşlemleri',
      icon: 'folder',
      items: []
    };
    if (hasRole("tesvik|tesvikislemleri|listele")) {
      tesvikIslemleriMenu.items.push({
        text: 'Teşvik İşlemleri',
        path: '/tesvik'
      });
    }
    if (hasRole("tesvik|tesvikDetayIslemleri|listele")) {
      tesvikIslemleriMenu.items.push({
        text: 'Teşvik Detay İşlemleri',
        path: '/tesvikDetay'
      });
    }

    menu.push(tesvikIslemleriMenu);
  }

  //tesvikRapor  meu-forms
  if (hasRoles(["tesvikRapor|tesvikRaporislemleri|raporIslemleri", "tesvikRapor|tesvikRaporFarkIslemleri|raporFarkIslemleri", "tesvikRaporBilgi|tesvikRaporBilgiIslemleri|raporIslemleri"])) {
    let raporIslemleriMenu = {
      text: 'Rapor İşlemleri',
      icon: 'folder',
      items: []
    };
    if (hasRole("tesvikRapor|tesvikRaporislemleri|raporIslemleri")) {
      raporIslemleriMenu.items.push({
        text: 'Teşvik Rapor',
        path: '/tesvikRapor'
      });
    }
    if (hasRole("tesvikRapor|tesvikRaporFarkIslemleri|raporFarkIslemleri")) {
      raporIslemleriMenu.items.push({
        text: 'Teşvik Rapor Fark',
        path: '/tesvikRaporFark'
      });
    }
    if (hasRole("tesvikRaporBilgi|tesvikRaporBilgiIslemleri|raporIslemleri")) {
      raporIslemleriMenu.items.push({
        text: 'Teşvik Rapor Bilgi',
        path: '/tesvikRaporBilgi'
      });
    }
    if (hasRole("tesvikRapor|domainMufredatBilgiDetay|mufredatDetayBilgiRaporIslemleri")) {
      raporIslemleriMenu.items.push({
        text: 'Asgari Ücret Destek Rapor Fark ',
        path: '/asgariUcretRaporFark'
      });
    }


    menu.push(raporIslemleriMenu);
  }

  //cariDonem  meu-forms
  if (hasRoles(["cariDonem|cariDonemTesvikRapor|cariDonemFirmaListeleme","cariDonemFinansRapor|cariDonemFinansRapor|listele"])) {
    let cariDonemIslemleriMenu = {
      text: 'Cari Dönem İşlemleri',
      icon: 'folder',
      items: []
    };
    if (hasRole("cariDonem|cariDonemTesvikRapor|cariDonemFirmaListeleme")) {
      cariDonemIslemleriMenu.items.push({
        text: 'Cari Dönem Rapor İşlemleri',
        path: '/cariDonemRapor'
      });
    }
    if (hasRole("cariDonemFinansRapor|cariDonemFinansRapor|listele")) {
      cariDonemIslemleriMenu.items.push({
        text: 'Cari Dönem Finans Rapor İşlemleri',
        path: '/cariDonemFinansRapor'
      });
    }
    menu.push(cariDonemIslemleriMenu);
  }


  //tanimlar  meu-forms
  if (hasRoles([
    "tanimlar|domain|listele",
    "tanimlar|kullaniciDomain|listele",
    "tanimlar|roleTanim|listele",
    "tanimlar|selenium|listele",
    "tanimlar|rolKullanici|listele",
    "tanimlar|kullanici|listele",
    "tanimlar|tesviktanimi|listele"
  ])) {
    let tanimlarMenu = {
      text: 'Tanımlar',
      icon: 'folder',
      items: []
    };

    if (hasRole("tanimlar|domain|listele")) {
      tanimlarMenu.items.push({
        text: 'Firma',
        path: '/firma'
      });
    }

    if (hasRole("tanimlar|kullanici|listele")) {
      tanimlarMenu.items.push({
        text: 'Kullanıcı',
        path: '/kullanici'
      });
    }

    if (hasRole("tanimlar|roleTanim|listele")) {
      tanimlarMenu.items.push({
        text: 'Rola Tanım',
        path: '/roleGroup'
      });
    }
    if (hasRole("tanimlar|tesviktanimi|listele")) {
      tanimlarMenu.items.push({
        text: 'Teşvik Tanımı ',
        path: '/tesviktanimi'
      });
    }

    if (hasRole("tanimlar|selenium|listele")) {
      tanimlarMenu.items.push({
        text: 'Selenium ',
        path: '/seleniumRemote'
      });
    }

    menu.push(tanimlarMenu);
  }



  //       {
  //         text: 'Rol Kullanıcı Grup ',
  //         path: '/rolKullaniciGrup'
  //       }


  return menu;
}


export const navigation = getMenu();
 